export const messages = {
  en: {
    complaintDetail: {
      title: 'Complaint Details',
      workflow: 'Workflow',
      evaluation: 'Evaluation',
      type: 'Type'
    },
    complaintDetailInfo: {
      orderNo: 'Order No:',
      type: 'Type:',
      house: 'House:',
      contact: 'Contact:',
      phone: 'Phone:',
      status: 'Status:',
      createTime: 'Create Time:',
      content: 'Content:'
    },
    complaintDetailEvent: {
      type: 'Type',
      operator: 'Operator',
      remark: 'Remark',
      time: 'Time',
      submit: 'Submit',
      process: 'Process',
      evaluate: 'Evaluate',
      reply: 'Reply'
    },
    complaintDetailAppraise: {
      userName: 'User Name',
      content: 'Content',
      score: 'Score',
      status: 'Status',
      time: 'Time',
      replyUser: 'Reply User',
      replyContent: 'Reply Content',
      operation: 'Operation',
      reply: 'Reply',
      waitReply: 'Wait Reply',
      replied: 'Replied'
    },
    replyComplaintAppraise: {
      title: 'Reply Evaluation',
      content: 'Content',
      placeholder: 'Required, please enter reply content',
      required: 'Reply content is required',
      maxLength: 'Reply content exceeds 500 characters',
      success: 'Reply successfully'
    },
    complaintDetailType: {
      typeName: 'Type Name',
      notifyWay: 'Notify Way',
      appraiseReply: 'Appraise Reply',
      handler: 'Handler',
      createTime: 'Create Time',
      sms: 'SMS',
      wechat: 'WeChat',
      autoReply: 'Auto Reply',
      manualReply: 'Manual Reply'
    }
  },
  zh: {
    complaintDetail: {
      title: '投诉详情',
      workflow: '工单流转',
      evaluation: '工单评价',
      type: '工单类型'
    },
    complaintDetailInfo: {
      orderNo: '订单编号：',
      type: '类型：',
      house: '房屋：',
      contact: '联系人：',
      phone: '联系电话：',
      status: '状态：',
      createTime: '创建时间：',
      content: '投诉内容：'
    },
    complaintDetailEvent: {
      type: '类型',
      operator: '操作人',
      remark: '说明',
      time: '时间',
      submit: '提交',
      process: '投诉处理',
      evaluate: '评价',
      reply: '评价回复'
    },
    complaintDetailAppraise: {
      userName: '用户名称',
      content: '评价内容',
      score: '评价得分',
      status: '评价状态',
      time: '评价时间',
      replyUser: '回复人',
      replyContent: '回复内容',
      operation: '操作',
      reply: '回复',
      waitReply: '待回复',
      replied: '已回复'
    },
    replyComplaintAppraise: {
      title: '回复评价',
      content: '内容',
      placeholder: '必填，请填写回复内容',
      required: '回复内容不能为空',
      maxLength: '回复内容超过500个字',
      success: '回复成功'
    },
    complaintDetailType: {
      typeName: '类型名称',
      notifyWay: '通知方式',
      appraiseReply: '评价回复',
      handler: '处理人',
      createTime: '创建时间',
      sms: '短信',
      wechat: '微信',
      autoReply: '自动回复',
      manualReply: '人工回复'
    }
  },
  'zh-TW': {
    complaintDetail: {
      title: '投訴詳情',
      workflow: '工單流轉',
      evaluation: '工單評價',
      type: '工單類型'
    },
    complaintDetailInfo: {
      orderNo: '訂單編號：',
      type: '類型：',
      house: '房屋：',
      contact: '聯繫人：',
      phone: '聯繫電話：',
      status: '狀態：',
      createTime: '創建時間：',
      content: '投訴內容：'
    },
    complaintDetailEvent: {
      type: '類型',
      operator: '操作人',
      remark: '說明',
      time: '時間',
      submit: '提交',
      process: '投訴處理',
      evaluate: '評價',
      reply: '評價回復'
    },
    complaintDetailAppraise: {
      userName: '用戶名稱',
      content: '評價內容',
      score: '評價得分',
      status: '評價狀態',
      time: '評價時間',
      replyUser: '回復人',
      replyContent: '回復內容',
      operation: '操作',
      reply: '回復',
      waitReply: '待回復',
      replied: '已回復'
    },
    replyComplaintAppraise: {
      title: '回復評價',
      content: '內容',
      placeholder: '必填，請填寫回復內容',
      required: '回復內容不能為空',
      maxLength: '回復內容超過500個字',
      success: '回復成功'
    },
    complaintDetailType: {
      typeName: '類型名稱',
      notifyWay: '通知方式',
      appraiseReply: '評價回復',
      handler: '處理人',
      createTime: '創建時間',
      sms: '短信',
      wechat: '微信',
      autoReply: '自動回復',
      manualReply: '人工回復'
    }
  }
}